<template>
    <v-btn v-on="$listeners" v-bind="attrs" elevation="0">
        <v-icon left v-if="leftIcon" v-text="leftIcon" v-bind="attrsIcon"></v-icon>
        <slot></slot>
        <v-icon right v-if="rightIcon" v-text="rightIcon" v-bind="attrsIcon"></v-icon>
    </v-btn>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        leftIcon: {
            type: String,
            required: false,
            default: null,
        },
        rightIcon: {
            type: String,
            required: false,
            default: null,
        },
        size: {
            type: String,
            required: false,
            validator: (value) =>
                ["small", "x-small", "normal", "large", "x-large"].includes(value),
        },
    },
    computed: {
        attrs() {
            const { elevation, ...attrs } = this.$attrs
            return { ...this.propsSize, ...attrs };
        },
        attrsIcon() {
            return this.propsSize;
        },
        propsSize() {
            return this.size && this.size !== "normal" ? { [this.size]: true } : {};
        },
    },
};
</script>

<style scoped lang="scss">
.v-btn:not(.v-btn--round).v-size--default {
    padding: 0px 20px;
}
.v-btn.secondary {
    border: 2px solid var(--v-neutral-2-base) !important;
    background-color: var(--v-white-base) !important;
    color: var(--v-neutral-4-base) !important;
}
</style>
